import api from './api';

export const collaboratorService = {
  // Criar novo colaborador
  create: async (eventId, collaboratorData) => {
    const response = await api.post('/collaborators', {
      eventId,
      ...collaboratorData
    });
    return response.data;
  },

  // Listar colaboradores de um evento
  getByEventId: async (eventId) => {
    const response = await api.get(`/collaborators/event/${eventId}`);
    return response.data;
  },

  // Atualizar role de colaborador
  updateRole: async (collaboratorId, role) => {
    const response = await api.put(`/collaborators/${collaboratorId}/role`, { role });
    return response.data;
  },

  // Remover colaborador
  remove: async (collaboratorId) => {
    const response = await api.delete(`/collaborators/${collaboratorId}`);
    return response.data;
  },

  // Trocar senha (para colaboradores)
  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/collaborators/change-password', {
      currentPassword,
      newPassword
    });
    return response.data;
  },

  // Resetar senha de colaborador (apenas dono do evento)
  resetPassword: async (collaboratorId) => {
    const response = await api.post(`/collaborators/${collaboratorId}/reset-password`);
    return response.data;
  }
};
